import script from "./icon-two-tones-book-saved.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-book-saved.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-book-saved.vue?vue&type=style&index=0&id=6186df0a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6186df0a"]])

export default __exports__